<script>
  import AppPageHeader from '../../../components/main/PageHeader'
  import EmptyList from '../../../components/list/EmptyList'

  import * as restfulService from '../../../services/restfulService'
  import * as $contratoService from '../services/contratoService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapGetters} from 'vuex'

  export default {
    mixins: [helpers],
    components: {AppPageHeader, EmptyList},
    mounted () {
      this.carregarContratos()
      this.buscarSituacaoAluno()
    },
    data () {
      return {
        contrato: null,
        periodo: null,
        contratos: [],
        periodos: [],
        mostratModalAtestado: false,
        atestadoBase64: '',
        matriculado: false
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      habilitarGeracaoAtestado: function () {
        return this.contrato && this.periodo && this.matriculado
      }
    },
    methods: {
      buscarSituacaoAluno () {
        restfulService.get('dashboard', 'popup-pre-matriculado')
          .then(response => {
            if (!response.pre_matriculado) {
              this.matriculado = true
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      carregarContratos () {
        $contratoService.buscarContratos()
          .then((response) => {
            this.contratos = [...this.contratos, ...response]
            if (this.contratos.length === 1) {
              this.contrato = this.contratos[0].id
              this.selecionaContrato(this.contrato)
            }
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      selecionaContrato (value) {
        if (value) {
          bus.$emit('show-loader')
          $contratoService.buscarPeriodosAtivos(value)
            .then((response) => {
              this.periodos = [...this.periodos, ...response]
              bus.$emit('hide-loader')
            })
            .catch(e => {
              bus.$emit('hide-loader')
              console.log(e)
            })
        } else {
          this.periodo = null
          this.periodos.splice(0)
        }
      },
      gerarAtestado () {
        bus.$emit('show-loader', {message: 'Estamos gerando o seu atestado'})
        let data = {
          ref_contrato: this.contrato,
          ref_periodo: this.periodo
        }
        restfulService.post('trancamento', 'pdf', null, data)
          .then((response) => {
            if (response.base64) {
              this.atestadoBase64 = 'data:application/pdf;base64,' + response.base64
            }
            this.mostratModalAtestado = true
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="page-content">
        <app-page-header/>
        <div class="box">
            <v-container fluid grid-list-md>
                <v-layout row wrap>
                    <v-flex sm6 xs12>
                        <v-select :items="contratos"
                                  v-model="contrato"
                                  label="Curso"
                                  no-data-text="Nenhum curso encontrado"
                                  clearable
                                  @input="selecionaContrato"
                                  item-value="id"
                                  item-text="descricao"/>
                    </v-flex>
                    <v-flex sm6 xs12>
                        <v-select :items="periodos"
                                  v-model="periodo"
                                  label="Período"
                                  no-data-text="Nenhum períodos encontrado"
                                  clearable
                                  item-value="periodo"
                                  item-text="descricao"/>
                    </v-flex>
                </v-layout>
            </v-container>
            <empty-list v-if="!habilitarGeracaoAtestado"
                        title="Selecione o Curso/Período"
                        description="Para habilitar a geração do atestado você precisa selecionar o curso e período"/>
            <div class="text-xs-center atestados-gerar-botoes">
                <v-btn color="primary" large
                       :disabled="!habilitarGeracaoAtestado"
                       @click="gerarAtestado()">
                    <i class="fas fa-print"></i>
                    <span class="pl-1">Gerar Atestado</span>
                </v-btn>
            </div>
        </div>
        <v-dialog v-model="mostratModalAtestado" width="80%">
            <v-card class="modal-pdf">
                <v-card-text>
                    <iframe :src="atestadoBase64"></iframe>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostratModalAtestado = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style>
    .atestados-gerar-botoes {
        padding-bottom: 15px;
    }
</style>



// WEBPACK FOOTER //
// AtestadoTrancamento.vue?0758ffc5